// Modal system. Just use class js-m-modal + data-modal="id" + data-effect="slide-top"
;
(function () {

    var modalDuration = 800,
        modalDelay = 350,
        modalEasing = '[0.23, 1, 0.32, 1]';

    var modules = {
        $window: $(window),
        $html: $('html'),
        $body: $('body'),
        $container: $('.m-modal-wrap'),

        init: function () {
            $(function () {
                modules.modals.init();
            });
        },

        modals: {
            trigger: $('.js-m-modal'),
            modal: $('.m-modal'),
            scrollTopPosition: null,

            init: function () {
                var self = this;

                if (self.trigger.length > 0 && self.modal.length > 0) {
                    modules.$container.append('<div class="m-modal-overlay"></div>');

                    self.triggers();
                }
            },

            triggers: function () {
                var self = this;

                self.trigger.on('click', function (e) {
                    e.preventDefault();

                    var $trigger = $(this);

                    self.openModal($trigger, $trigger.data('modalTarget'), $trigger.data('modalEffect'));
                });

                $('.m-modal-overlay').on('click', function (e) {
                    e.preventDefault();
                    self.closeModal();
                });

                $('.m-modal-dialog').on('click', function (e) {
                    e.preventDefault();
                    self.closeModal();
                });

                $('.m-modal-content').on('click', function (e) {
                    e.stopPropagation();
                });

                modules.$html.on('keydown', function (e) {
                    if (e.keyCode === 27) {
                        self.closeModal();
                    }
                });

                $('.js-modal-close').on('click', function (e) {
                    e.preventDefault();
                    self.closeModal();
                });
            },

            openModal: function (_trigger, _modalTarget, _modalEffect) {
                var self = this,
                    scrollTopPosition = modules.$window.scrollTop(),
                    $targetModal = $('#' + _modalTarget);


                self.scrollTopPosition = scrollTopPosition;

                modules.$html.addClass('m-modal--shown');
                modules.$html.addClass('u-hidden');
                modules.$body.addClass('u-hidden');

                $(document).trigger('modalBeforeOpen');

                // modules.$body.addClass('u-scroll--stop');
                // modules.$body.css('top', -scrollTopPosition);

                $targetModal.css('overflow', 'hidden');
                $targetModal.addClass('m-modal--active').attr('data-modal-effect', _modalEffect);
                var $targetDialog = $targetModal.find('.m-modal-dialog');
                $targetDialog.removeAttr("style");

                $(document).trigger('modalOpened');

                // Use velocity js for this

                if (_modalEffect === 'slideUpIn') {
                    $targetDialog.velocity('transition.slideUpIn', {
                        duration: modalDuration,
                        easing: modalEasing
                    });
                } else if (_modalEffect === 'slideUpBigIn') {
                    $targetDialog.velocity('transition.slideUpBigIn', {
                        duration: modalDuration,
                        easing: modalEasing
                    });
                } else if (_modalEffect === 'slideDownIn') {
                    $targetDialog.velocity('transition.slideDownIn', {
                        duration: modalDuration,
                        easing: modalEasing
                    });
                } else if (_modalEffect === 'slideDownBigIn') {
                    $targetDialog.velocity('transition.slideDownBigIn', {
                        duration: modalDuration,
                        easing: modalEasing
                    });
                } else if (_modalEffect === 'slideLeftBigIn') {
                    $targetDialog.velocity('transition.slideLeftBigIn', {
                        duration: modalDuration,
                        easing: modalEasing
                    });
                } else if (_modalEffect === 'slideLeftIn') {
                    $targetDialog.velocity('transition.slideLeftIn', {
                        duration: modalDuration,
                        easing: modalEasing
                    });
                } else if (_modalEffect === 'slideRightBigIn') {
                    $targetDialog.velocity('transition.slideRightBigIn', {
                        duration: modalDuration,
                        easing: modalEasing
                    });
                } else if (_modalEffect === 'slideRightIn') {
                    $targetDialog.velocity('transition.slideRightIn', {
                        duration: modalDuration,
                        easing: modalEasing
                    });
                } else if (_modalEffect === 'expandIn') {
                    $targetDialog.velocity('transition.expandIn', {
                        duration: modalDuration,
                        easing: modalEasing
                    });
                } else if (_modalEffect === 'shrinkIn') {
                    $targetDialog.velocity('transition.shrinkIn', {
                        duration: modalDuration,
                        easing: modalEasing
                    });
                } else if (_modalEffect === 'bounceDownIn') {
                    $targetDialog.velocity('transition.bounceDownIn', {
                        duration: modalDuration,
                        easing: modalEasing
                    });
                }

                setTimeout(function () {
                    $targetModal.css('overflow', '');
                }, modalDuration);

                modules.$container.scrollTop(scrollTopPosition);
            },

            closeModal: function () {
                var self = this;
                var $targetModal = $('.m-modal--active');
                var $targetDialog = $targetModal.find('.m-modal-dialog');
                $targetDialog.velocity("reverse", {
                    complete: function () {
                        modules.$html.removeClass('m-modal--shown');
                        modules.$html.removeClass('u-hidden');
                        modules.$body.removeClass('u-hidden');
                        // modules.$body.removeClass('u-scroll--stop');
                        // modules.$body.css('top', '');
                        modules.$window.scrollTop(self.scrollTopPosition);

                        $(document).trigger('modalClosed');
                    }
                });

                $targetModal.removeClass('m-modal--active').removeAttr('data-modal-effect');
            }
        }
    };

    modules.init();


})();

// modal scrollbar fix
(function () {
    var div = document.createElement('div');
    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';
    div.style.visibility = 'hidden';
    document.body.appendChild(div);
    var scrollbar_width = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);

    // Events
    $(document)
        .on('modalBeforeOpen', function () {
            $('body').css('padding-right', scrollbar_width);
        })
        .on('modalClosed', function () {
            $('body').css('padding-right', '');
        });
})();
